export default __webpack_public_path__ + "static/media/jackalMint.ab877891.png";